import type { FilterRange, SuffixMap } from "./index";

export enum DRESON_PREFIX {
  IST = "ist",
  AB = "ab",
  BIS = "bis",
  SUCHBEGRIFF = "suchbegriff",
}

export enum FILTER_NAME {
  LIEFERZEIT = "Lieferaussage",
  PREIS = "Preis in eur",
  RABATT = "Rabatt",
  SORTIERT_NACH = "sortiertnach",
  REDIRECT = "_redirect",
}

export const FilterBlacklist: (DRESON_PREFIX.SUCHBEGRIFF | FILTER_NAME)[] = [
  DRESON_PREFIX.SUCHBEGRIFF,
  FILTER_NAME.LIEFERZEIT,
  FILTER_NAME.REDIRECT,
];

export const FilterSuffixMap: SuffixMap = {
  [FILTER_NAME.PREIS]: " €",
  [FILTER_NAME.RABATT]: " %",
};
export const SortingMap: Map<string, string> = new Map([
  ["topseller", "Topseller"],
  ["preis-aufsteigend", "Preis: niedrigster zuerst"],
  ["preis-absteigend", "Preis: höchster zuerst"],
  ["hoechste-reduzierung", "Höchste Reduzierung"],
  ["neuheiten", "Neuheiten"],
  ["bewertung", "Bewertungen"],
]);

export function isFilterRange(value: unknown): value is FilterRange {
  return !!(
    value &&
    typeof value == "object" &&
    (typeof Reflect.get(value, DRESON_PREFIX.BIS) === "string" ||
      typeof Reflect.get(value, DRESON_PREFIX.AB) === "string")
  );
}
